import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import NagusiBackNav from '../common/NagusiBackNav';
export default class AchievementsClassificationPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.loadingMore = false;
    this.ranking = [];
    this.totalAchievements = 0;
    this.limit = 20;
    this.offset = 0;
    this.hasMore = false;
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.offset = 0;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/achievements-classification',
      params: {
        page: {
          limit: this.limit,
          offset: this.offset
        },
        include: 'user'
      }
    }).then(response => {
      var _response$meta;
      this.totalAchievements = ((_response$meta = response.meta) == null ? void 0 : _response$meta.totalAchievements) || 0;
      const results = app.store.pushPayload(response) || [];
      this.ranking = results;
      this.hasMore = results.length >= this.limit;
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      console.error(err);
      m.redraw();
    });
  }
  loadMore() {
    if (this.loadingMore) return;
    this.loadingMore = true;
    this.offset += this.limit;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/achievements-classification',
      params: {
        page: {
          limit: this.limit,
          offset: this.offset
        },
        include: 'user'
      }
    }).then(response => {
      const results = app.store.pushPayload(response) || [];
      this.ranking = this.ranking.concat(results);
      this.hasMore = results.length >= this.limit;
      this.loadingMore = false;
      m.redraw();
    }).catch(err => {
      this.loadingMore = false;
      console.error(err);
      m.redraw();
    });
  }
  isCurrentUser(user) {
    return app.session.user && String(app.session.user.id()) === String(user.id());
  }
  scrollToUser(userId) {
    let el = document.getElementById("achievements-user-row-".concat(userId));
    if (!el) {
      el = document.getElementById("achievements-podium-user-".concat(userId));
    }
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      el.classList.remove('is-flashing');
      void el.offsetWidth;
      el.classList.add('is-flashing');
      setTimeout(() => {
        if (el) el.classList.remove('is-flashing');
      }, 2600);
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const ranks = [];
    const ties = [];
    let currentRank = 1;
    for (let i = 0; i < this.ranking.length; i++) {
      if (i > 0 && this.ranking[i].achievementsCount() !== this.ranking[i - 1].achievementsCount()) {
        currentRank = i + 1;
      }
      ranks[i] = currentRank;
    }
    for (let i = 0; i < this.ranking.length; i++) {
      const r = ranks[i];
      ties[i] = ranks.filter(x => x === r).length > 1;
    }
    const top3 = this.ranking.slice(0, 3);
    return m("div", {
      className: "BolillaPage AchievementsClassificationPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      title: "Clasificaci\xF3n por Logros"
    }), m("h2", {
      className: "BolillaPage-Title"
    }, "Clasificaci\xF3n por Logros"), top3.length > 0 && m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Podium"
    }, top3[1] && this.renderPodiumUser(top3[1], ranks[1]), top3[0] && this.renderPodiumUser(top3[0], ranks[0]), top3[2] && this.renderPodiumUser(top3[2], ranks[2]))), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Season-Statistics",
      style: {
        width: '100%'
      }
    }, m("div", {
      className: "Top-Players-Full-Table"
    }, m("div", {
      className: "achievements-summary-banner",
      style: {
        marginBottom: '20px',
        padding: '15px',
        background: 'var(--control-bg)',
        borderRadius: '8px',
        border: '1px solid var(--muted-color)',
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
      }
    }, m("span", {
      style: {
        fontSize: '2em'
      }
    }, "\uD83C\uDFC6"), m("div", null, m("h5", {
      style: {
        margin: 0
      }
    }, "Logros del Foro"), m("p", {
      style: {
        margin: 0,
        fontSize: '0.9em',
        color: 'var(--muted-color)'
      }
    }, "Hay un total de ", m("strong", null, this.totalAchievements), " logros disponibles para desbloquear. \xA1Participa en el foro y cons\xEDguelos todos!"))), m("div", {
      className: "Classification-Header-Actions"
    }, m("h4", null, "Clasificaci\xF3n General"), (() => {
      const currentUserId = app.session.user ? app.session.user.id() : null;
      if (!currentUserId) return null;
      const userRankIndex = this.ranking.findIndex(entry => entry.user() && String(entry.user().id()) === String(currentUserId));
      if (userRankIndex === -1) return null;
      const myRank = ranks[userRankIndex];
      return m(Button, {
        className: "Button Button--my-position",
        onclick: () => this.scrollToUser(currentUserId),
        icon: "fas fa-crosshairs"
      }, m("span", null, "Mi posici\xF3n (", myRank, "\xBA)"));
    })()), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, "Usuario"), m("th", {
      className: "center"
    }, "Logros Conseguidos"), m("th", {
      className: "center"
    }, "Detalles"))), m("tbody", null, this.ranking.map((entry, index) => {
      const user = entry.user();
      if (!user) return null;
      const userUrl = app.route('userAchievements', {
        username: user.slug()
      });
      const isCurrent = this.isCurrentUser(user);
      const rank = ranks[index];
      return m("tr", {
        key: user.id(),
        id: "achievements-user-row-".concat(user.id()),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info"
      }, m("span", {
        className: "rank-badge-cell"
      }, m("span", {
        className: "rank-badge rank-".concat(rank)
      }, rank, "\xBA")), m(Link, {
        href: userUrl
      }, avatar(user, {
        className: 'Player-Avatar-Tiny'
      })), m(Link, {
        href: userUrl,
        className: "Player-Name"
      }, username(user)), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"))), m("td", {
        className: "center bold",
        style: {
          fontSize: '1.1em'
        }
      }, entry.achievementsCount()), m("td", {
        className: "center"
      }, m(Link, {
        href: userUrl,
        className: "Button Button--link"
      }, m("i", {
        className: "fas fa-info-circle"
      }), m("span", {
        className: "Button-label",
        style: {
          marginLeft: '5px'
        }
      }, "Detalles"))));
    })))), this.hasMore && m("div", {
      className: "load-more-container",
      style: {
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '20px'
      }
    }, m(Button, {
      className: "Button Button--primary",
      onclick: this.loadMore.bind(this),
      loading: this.loadingMore
    }, "Ver m\xE1s")))))));
  }
  renderPodiumUser(entry, position) {
    const user = entry.user();
    if (!user) return null;
    const isFirst = position === 1;
    const userUrl = app.route('userAchievements', {
      username: user.slug()
    });
    const isCurrent = this.isCurrentUser(user);
    return m("div", {
      id: "achievements-podium-user-".concat(user.id()),
      className: "Podium-Player pos-".concat(position, " ").concat(isFirst ? 'MVP' : '', " ").concat(isCurrent ? 'highlight-current-user' : '')
    }, m(Link, {
      href: userUrl,
      className: "Player-Avatar-Wrapper"
    }, avatar(user), m("div", {
      className: "Rank-Badge"
    }, position)), m("div", {
      className: "Player-Details"
    }, m(Link, {
      href: userUrl,
      className: "Player-Name"
    }, username(user), isCurrent && m("span", {
      className: "badge-you"
    }, "T\xDA")), m("div", {
      className: "Player-Score-Container"
    }, m("span", {
      className: "Player-Average"
    }, entry.achievementsCount()), m("span", {
      className: "Label"
    }, "logros"))), isFirst && m("div", {
      className: "MVP-Crown"
    }, m("i", {
      className: "fas fa-crown"
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/achievements/AchievementsClassificationPage', AchievementsClassificationPage);